export default __webpack_public_path__ + "static/media/phone-old.0d5b16d6.svg";